var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "record-screen_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h24v24H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#record-screen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5c1.249 0 2.31-.438 3.186-1.314.876-.875 1.314-1.937 1.314-3.186 0-1.249-.438-2.31-1.314-3.187C18.311 11.938 17.25 11.5 16 11.5c-1.249 0-2.31.438-3.187 1.313-.875.876-1.313 1.938-1.313 3.187 0 1.249.438 2.31 1.313 3.186.876.876 1.938 1.314 3.187 1.314zm.002 5a9.255 9.255 0 01-3.705-.748 9.597 9.597 0 01-3.018-2.03 9.591 9.591 0 01-2.03-3.016 9.245 9.245 0 01-.749-3.704c0-1.314.25-2.55.748-3.705a9.596 9.596 0 012.03-3.018 9.591 9.591 0 013.016-2.03 9.245 9.245 0 013.704-.749c1.314 0 2.55.25 3.705.748a9.597 9.597 0 013.018 2.03 9.592 9.592 0 012.03 3.016 9.245 9.245 0 01.749 3.704c0 1.314-.25 2.55-.748 3.705a9.598 9.598 0 01-2.03 3.018 9.592 9.592 0 01-3.016 2.03 9.245 9.245 0 01-3.704.749zM16 24c2.233 0 4.125-.775 5.675-2.325C23.225 20.125 24 18.233 24 16c0-2.233-.775-4.125-2.325-5.675C20.125 8.775 18.233 8 16 8c-2.233 0-4.125.775-5.675 2.325C8.775 11.875 8 13.767 8 16c0 2.233.775 4.125 2.325 5.675C11.875 23.225 13.767 24 16 24z",
    fill: "#212121"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/record-screen.2ae17b82.svg";
export { SvgRecordScreen as ReactComponent };